import { Navbar } from "@/components/Navbar";
import { DropBanner } from "@/components/DropBanner";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { ProductGrid } from "@/components/ProductGrid";
import { Manifesto } from "@/components/Manifesto";
import { SoldGallery } from "@/components/SoldGallery";
import { ContactSection } from "@/components/ContactSection";
import { Footer } from "@/components/Footer";

export default function Home() {
  return (
    <main id="top">
      <Navbar />
      <DropBanner />
      <Hero />
      <Marquee />
      <ProductGrid />
      <Manifesto />
      <SoldGallery />
      <ContactSection />
      <Footer />
    </main>
  );
}
